//- single Gallery
let chaGalB = $('#single_gallery--btn')[0];
if (chaGalB) {

    chaGalB.onclick = function () {
        var lightbox = new FsLightbox();
        // set up props, like sources, types, events etc.
        lightbox.props.sources = fslightCollection;
        lightbox.props.showThumbsOnMount = true;
        lightbox.open();
    }
}

let chaGalB1 = $('#single_gallery--btn-1')[0];
if (chaGalB1) {
    chaGalB1.onclick = function () {
        
        var lightbox = new FsLightbox();
        // set up props, like sources, types, events etc.
        lightbox.props.sources = fslightCollection;
        lightbox.props.showThumbsOnMount = true;
        lightbox.open();
    }
}

let chaGalB2 = $('#single_gallery--btn-2')[0];
if (chaGalB2) {
    var fslightCollection = fslightCollections3;
    var lightbox = new FsLightbox();
    // set up props, like sources, types, events etc.
    lightbox.props.sources = fslightCollection;
    lightbox.props.showThumbsOnMount = true;
    lightbox.open();
}

$('.contenu_gallery--btn').click(function (e) {
    var indexCollection = $(e.target).closest('.contenu_gallery--btn').attr('data-collection-index');
    console.log(indexCollection);
    var lightbox = new FsLightbox();
    // set up props, like sources, types, events etc.
    lightbox.props.sources = fslightCollections[indexCollection];
    lightbox.props.showThumbsOnMount = true;
    lightbox.open();
});

$('body').on('click', 'button[data-season=1]:not(.season-toggle)', function () {
    console.log("click season 1");

    var fslightCollection = fslightCollections["1"];
    var lightbox = new FsLightbox();

    // set up props, like sources, types, events etc.
    lightbox.props.sources = fslightCollection;
    lightbox.props.showThumbsOnMount = true;
    lightbox.open();
});


$('body').on('click', 'button[data-season=2]:not(.season-toggle)', function () {
    console.log("click season 2");

    // Winter gallery
    var fslightCollection = fslightCollections["2"];
    var lightbox = new FsLightbox();

    // set up props, like sources, types, events etc.
    lightbox.props.sources = fslightCollection;
    lightbox.props.showThumbsOnMount = true;
    lightbox.open();
});

